import { InjectionToken } from '@angular/core';
import { Converter } from '@spartacus/core';
import { ScheduleReplenishmentForm } from '@spartacus/order/root';

export const REPLENISHMENT_ORDER_FORM_SERIALIZER = new InjectionToken<Converter<ScheduleReplenishmentForm, any>>(
  'ReplenishmentOrderFormSerializer'
);
